import Vue from 'vue'
import Router from 'vue-router'
const index = () => import(/* webpackChunkName: 'index' */ '@/view/index.vue')
const activityList = () =>
  import(
    /* webpackChunkName: 'activityList' */ '@/view/activity/activityList.vue'
  )
const activityDetails = () =>
  import(
    /* webpackChunkName: 'activityList' */ '@/view/activity/activityDetails.vue'
  )
const policyKnow = () =>
  import(/* webpackChunkName: 'policyKnow' */ '@/view/policyKnow.vue')
const allianceDynamic = () =>
  import(/* webpackChunkName: 'allianceDynamic' */ '@/view/allianceDynamic.vue')
const newsList = () =>
  import(/* webpackChunkName: 'newsList' */ '@/view/news/newsList.vue')
const newsDetails = () =>
  import(/* webpackChunkName: 'newsDetails' */ '@/view/news/newsDetails.vue')
const shopList = () =>
  import(/* webpackChunkName: 'shopList' */ '@/view/shop/shopList.vue')
const shopDetails = () =>
  import(/* webpackChunkName: 'shopDetails' */ '@/view/shop/shopDetails.vue')
const studyList = () =>
  import(/* webpackChunkName: 'studyList' */ '@/view/study/studyList.vue')
const studyDetails = () =>
  import(
    /* webpackChunkName: 'studyDetails' */ '@/view/study/studyDetails.vue'
  )
const aboutUs = () =>
  import(/* webpackChunkName: 'aboutUs' */ '@/view/aboutUs.vue')
const memberApply = () =>
  import(/* webpackChunkName: 'memberApply' */ '@/view/member/apply.vue')
// 状态页面
const error = () =>
  import(/* webpackChunkName: 'error' */ '@/view/statePage/error.vue')
const success = () =>
  import(/* webpackChunkName: 'success' */ '@/view/statePage/success.vue')
const auditSuccess = () =>
  import(
    /* webpackChunkName: 'auditSuccess' */ '@/view/statePage/auditSuccess.vue'
  )
const applyFinish = () =>
  import(
    /* webpackChunkName: 'applyFinish' */ '@/view/statePage/applyFinish.vue'
  )
const auditFair = () =>
  import(/* webpackChunkName: 'auditFair' */ '@/view/statePage/auditFair.vue')
const paySuccess = () =>
  import(
    /* webpackChunkName: 'paySuccess' */ '@/view/statePage/paySuccess.vue'
  )
const wait = () =>
  import(/* webpackChunkName: 'wait' */ '@/view/statePage/wait.vue')
const remitConfirm = () =>
  import(
    /* webpackChunkName: 'remitConfirm' */ '@/view/statePage/remitConfirm.vue'
  )
// 个人中心
const mine = () =>
  import(/* webpackChunkName: 'mine' */ '@/view/mine/mine.vue')
const myActivity = () =>
  import(/* webpackChunkName: 'myActivity' */ '@/view/mine/myActivity.vue')
const myQRcode = () =>
  import(/* webpackChunkName: 'myQRcode' */ '@/view/mine/myQRcode.vue')
const myInfo = () =>
  import(/* webpackChunkName: 'myInfo' */ '@/view/mine/myInfo.vue')
const myCollect = () =>
  import(/* webpackChunkName: 'myCollect' */ '@/view/mine/myCollect.vue')
const basicInfo = () =>
  import(/* webpackChunkName: 'basicInfo' */ '@/view/activity/basicInfo.vue')
const formElements = () =>
  import(
    /* webpackChunkName: 'formElements' */ '@/view/activity/formElements.vue'
  )
const onLinePay = () =>
  import(/* webpackChunkName: 'onLinePay' */ '@/view/member/onLinePay.vue')
const offLinePay = () =>
  import(/* webpackChunkName: 'offLinePay' */ '@/view/member/offLinePay.vue')
const transferLogin = () =>
  import(/* webpackChunkName: 'transferLogin' */ '@/view/transferLogin.vue')

const cmsCategoryDetail = () =>
  import('@/view/cmsCategory/categoryDetail.vue')

Vue.use(Router)

var router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: index,
      meta: {
        title: '江苏省企业信息化协会'
      }
    },
    {
      path: '/onLinePay',
      component: onLinePay,
      meta: {
        title: '线上支付'
      }
    },
    {
      path: '/offLinePay',
      component: offLinePay,
      meta: {
        title: '线下支付'
      }
    },
    {
      path: '/activity/activityList',
      component: activityList,
      name: 'activityList',
      meta: {
        title: '活动'
      }
    },
    {
      path: '/activity/basicInfo',
      component: basicInfo,
      name: 'basicInfo',
      meta: {
        title: '信息确认'
      }
    },
    {
      path: '/activity/activityDetails',
      component: activityDetails,
      name: 'activityDetails',
      meta: {
        title: '活动详情'
      }
    },
    {
      path: '/activity/detail/:id',
      component: activityDetails,
      name: 'activity-detail',
      meta: {
        title: '活动详情'
      }
    },
    {
      path: '/activity/formElements',
      component: formElements,
      name: 'formElements',
      meta: {
        title: '报名表单'
      }
    },
    {
      path: '/policyKnow',
      component: policyKnow,
      name: 'policyKnow',
      meta: {
        title: '政知道'
      }
    },
    {
      path: '/allianceDynamics',
      component: allianceDynamic,
      name: 'allianceDynamics',
      meta: {
        title: '联盟动态'
      }
    },
    {
      path: '/news/newsList',
      component: newsList,
      name: 'newsList',
      meta: {
        title: '资讯'
      }
    },
    {
      path: '/news/newsDetails/:id',
      component: newsDetails,
      name: 'newsDetails',
      meta: {
        title: '资讯详情'
      }
    },
    {
      path: '/news/detail/:id',
      component: newsDetails,
      name: 'news-detail',
      meta: {
        title: '资讯详情'
      }
    },
    {
      path: '/shop/shopList',
      component: shopList,
      name: 'shopList',
      meta: {
        title: '战疫产品'
      }
    },
    {
      path: '/shop/shopDetails',
      component: shopDetails,
      name: 'shopDetails',
      meta: {
        title: '战疫产品详情'
      }
    },
    {
      path: '/shop/detail/:id',
      component: shopDetails,
      name: 'shop-detail',
      meta: {
        title: '战疫产品详情'
      }
    },
    {
      path: '/study/studyList',
      component: studyList,
      name: 'studyList',
      meta: {
        title: '研习社'
      }
    },
    {
      path: '/study/studyDetails',
      component: studyDetails,
      name: 'studyDetails',
      meta: {
        title: '研习社详情'
      }
    },
    {
      path: '/study/detail/:id',
      component: studyDetails,
      name: 'study-detail',
      meta: {
        title: '研习社详情'
      }
    },
    {
      path: '/aboutUs',
      component: aboutUs,
      name: 'aboutUs',
      meta: {
        title: '协会介绍'
      }
    },
    {
      path: '/wxcallback',
      component: () =>
        import(
          /* webpackChunkName: 'account' */ '@/view/account/wxcallback.vue'
        ),
      name: 'wxcallback',
      meta: {
        title: '微信登录'
      }
    },

    {
      path: '/memberApply',
      component: memberApply,
      name: 'memberApply',
      meta: {
        title: '会员申请'
      }
    },
    {
      path: '/member/renew',
      component: () =>
        import(/* webpackChunkName: 'member' */ '@/view/member/renew.vue'),
      name: 'member-renew',
      meta: {
        title: '续费'
      }
    },
    {
      path: '/statePage/error',
      component: error,
      meta: {
        title: '出错啦'
      }
    },
    {
      path: '/statePage/success',
      component: success,
      meta: {
        title: '报名成功'
      }
    },
    {
      path: '/statePage/auditSuccess',
      component: auditSuccess,
      name: 'auditSuccess',
      meta: {
        title: '审核成功'
      }
    },
    {
      path: '/statePage/remitConfirm',
      component: remitConfirm,
      name: 'remitConfirm',
      meta: {
        title: '等待确认'
      }
    },
    {
      path: '/statePage/applyFinish',
      component: applyFinish,
      name: 'applyFinish',
      meta: {
        title: '申请完成'
      }
    },
    {
      path: '/statePage/auditFair',
      component: auditFair,
      name: 'auditFair',
      meta: {
        title: '审核失败'
      }
    },
    {
      path: '/statePage/paySuccess',
      component: paySuccess,
      name: 'paySuccess',
      meta: {
        title: '支付成功'
      }
    },
    {
      path: '/statePage/wait',
      component: wait,
      name: 'wait',
      meta: {
        title: '等待审核'
      }
    },
    {
      path: '/mine/mine',
      component: mine,
      name: 'mine',
      meta: {
        title: '个人中心'
      },
      children: [
        {
          path: '/mine/myActivity',
          component: myActivity,
          name: 'myActivity',
          meta: {
            title: '我报名的活动'
          }
        },
        {
          path: '/mine/myQRcode',
          component: myQRcode,
          name: 'myQRcode',
          meta: {
            title: '我的二维码'
          }
        },
        {
          path: '/mine/myInfo',
          component: myInfo,
          name: 'myInfo',
          meta: {
            title: '我的资料'
          }
        },
        {
          path: '/mine/myCollect',
          component: myCollect,
          name: 'myCollect',
          meta: {
            title: '我的收藏'
          }
        }
      ]
    },
    {
      path: '/transferLogin',
      component: transferLogin,
      name: 'transferLogin',
      meta: {
        title: '登录转换'
      }
    },
    {
      path: '/serviceSystem/:categoryNo',
      component: cmsCategoryDetail,
      name: 'serviceSystemChildCategory',
      meta: {
        title: '服务体系'
      }
    },
    {
      path: '/serviceSystem/news/:category',
      component: newsList,
      name: 'serviceSystemNews',
      meta: {
        title: '服务体系'
      }
    }
  ]
})
export default router
router.beforeEach((to, from, next) => {
  // if (from.meta.title && from.path != to.path) {
  //   window.location = to.path
  // }
  next()
})



// WEBPACK FOOTER //
// ./src/router/index.js